import React, { useEffect } from 'react';
import '../css/work.css'

function Playground() {

    useEffect(() => {
        const handleScroll = () => {
            const reveals = document.querySelectorAll(".reveal");
            reveals.forEach((reveal) => {
                const windowHeight = window.innerHeight;
                const elementTop = reveal.getBoundingClientRect().top;
                const elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                    reveal.classList.add("revealed");
                } else {
                    reveal.classList.remove("revealed");
                }
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div id="playground">
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal"
                    style={{ transitionDelay: "0ms" }}
                >
                    <img src="./images/RVG.jpg" alt="Calendar Task Manager" />
                </a>
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal"
                    style={{ transitionDelay: "150ms" }}
                >
                    <img src="./images/DRP.jpg" alt="Development Agency Isometric Illustration" />
                </a>
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal"
                    style={{ transitionDelay: "300ms" }}
                >
                    <img src="./images/Free Press.jpg" alt="Home Automation Remote Control" />
                </a>

                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal"
                    style={{ transitionDelay: "450ms" }}
                >
                    <img src="./images/OSM (1).jpg" alt="Alarm Activity Concept" />
                </a>

                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal mt-3"
                    style={{ transitionDelay: "0ms" }}
                >
                    <img src="./images/ATF_01.jpg" alt="Calendar Task Manager" />
                </a>
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal mt-3"
                    style={{ transitionDelay: "150ms" }}
                >
                    <img src="./images/Mind over Matter.jpg" alt="Development Agency Isometric Illustration" />
                </a>
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal mt-3"
                    style={{ transitionDelay: "300ms" }}
                >
                    <img src="./images/Prodigal Son.jpg" alt="Home Automation Remote Control" />
                </a>
                <a
                    href="#!"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reveal mt-3"
                    style={{ transitionDelay: "450ms" }}
                >
                    <img src="./images/Dont Sweat.jpg" alt="Alarm Activity Concept" />
                </a>
            </div>

        </>
    )
}

export default Playground